import { render, staticRenderFns } from "./InvoiceDataForm.vue?vue&type=template&id=08b4616f"
import script from "./InvoiceDataForm.vue?vue&type=script&lang=js"
export * from "./InvoiceDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports